import { render } from "./AboutMyApp.vue?vue&type=template&id=338e7eeb&scoped=true&ts=true"
import script from "./AboutMyApp.vue?vue&type=script&lang=ts"
export * from "./AboutMyApp.vue?vue&type=script&lang=ts"

import "./AboutMyApp.vue?vue&type=style&index=0&id=338e7eeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338e7eeb"]])

export default __exports__